module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"no":{"createGame":"Skape spill","deleteGame":"Slett spill","publishGame":"Publiser spill","playGame":"Spill"},"en":{"createGame":"Create game","deleteGame":"Delete game","publishGame":"Publish game","playGame":"Play game"}}')
  delete Component.options._Ctor
}
